import { getAvatarColors, getInitials } from '../helpers';
import { IconShield } from './icons';
import * as styled from '../styles/testimonials-section';

type Props = {
  testimonials: Landing.Testimonial[];
};

export const TestimonialsSection = ({ testimonials }: Props) => (
  <styled.TestimonialsBg>
    <styled.TestimonialsInner>
      <styled.SectionHeading>
        Pros are already claiming their spot
      </styled.SectionHeading>
      <styled.SectionSub>
        From barbers to photographers, plumbers to creators — here's why they
        signed up.
      </styled.SectionSub>
      <styled.TestimonialsGrid>
        {testimonials.map((testimonial) => (
          <styled.TestimonialCard key={testimonial.name}>
            <styled.TestimonialHeader>
              <styled.VerifiedBadge>
                <IconShield /> Early access
              </styled.VerifiedBadge>
            </styled.TestimonialHeader>
            <styled.TestimonialQuote>
              "{testimonial.quote}"
            </styled.TestimonialQuote>
            <styled.TestimonialFooter>
              <styled.TestimonialAuthorRow>
                <styled.Avatar
                  $bg={getAvatarColors(testimonial.name).bg}
                  $color={getAvatarColors(testimonial.name).color}
                >
                  {getInitials(testimonial.name)}
                </styled.Avatar>
                <styled.TestimonialAuthor>
                  <styled.TestimonialName>
                    {testimonial.name}
                  </styled.TestimonialName>
                  <styled.TestimonialMeta>
                    {testimonial.title} · {testimonial.location}
                  </styled.TestimonialMeta>
                </styled.TestimonialAuthor>
              </styled.TestimonialAuthorRow>
            </styled.TestimonialFooter>
          </styled.TestimonialCard>
        ))}
      </styled.TestimonialsGrid>
    </styled.TestimonialsInner>
  </styled.TestimonialsBg>
);
